import { ESpecialOfferType } from '../api/models/payment/eligible-categories.types';
import { ActionsUnion, createAction } from '../helpers';

export enum ESpecialOfferActionType {
  GET_SUCCESS = 'SPECIAL_OFFER/GET_SUCCESS',
  GET_CALL_DONE = 'SPECIAL_OFFER/CALL/DONE',
  REDIRECT_TO_SO_PAYMENT_PAGE = 'REDIRECT_TO_SO_PAYMENT_PAGE',
}

interface IGetSpecialOfferPayload {
  type: ESpecialOfferType;
  startDate: string;
  endDate: string;
  paymentUrl: string;
}

interface IGetPaymentUrlSpecialOfferPayload {
  paymentSoUrl: string;
}

export const specialOfferActions = {
  getCurrentSpecialOfferSuccess: (payload: IGetSpecialOfferPayload) =>
    createAction(ESpecialOfferActionType.GET_SUCCESS, payload),
  getCurrentSpecialOfferCallDone: () =>
    createAction(ESpecialOfferActionType.GET_CALL_DONE),
  redirectToSpecialOfferPaymentPage: (
    payload: IGetPaymentUrlSpecialOfferPayload
  ) =>
    createAction(ESpecialOfferActionType.REDIRECT_TO_SO_PAYMENT_PAGE, payload),
};

export type TSpecialOfferAction = ActionsUnion<typeof specialOfferActions>;
